import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./privateRoute";
import SuzaLayout from "../layout";
import { Login, Lock, OTP } from "../pages/auth";
import Home from "../pages/home";
import { useInactivityLogout } from "../utils/inactivity";
import { Dictionary, DictionaryItem } from "../pages/dictionary";
import { Accademic, Campas, Department, Enrollment, Programme, School, TimeTable, Building, Room, ExamTimetable, UploadedTimetable } from "../pages/app";
import PublicTimetable from "../pages/public";
import RoomConstraints from "../components/app/settings/roomConstraints";
import InstructorPreferences from "../components/app/settings/instructorPreferences";



export default function Routers() {
  const logoutTime = 30 * 60 * 1000;

  useInactivityLogout(logoutTime);

  return (
    <>
      <Routes>
        {/* Public route - no authentication required */}
        <Route exact path="/ratiba" element={<PublicTimetable />} />

        <Route exact path="/" element={<Login />} />
        <Route exact path="/otp" element={<OTP />} />
        <Route exact path="/lockscreen" element={<Lock />} />
        <Route element={<SuzaLayout />}>
          <Route
            exact
            path="/home"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/dictionary"
            element={
              <PrivateRoute>
                <Dictionary />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/dictionary-item"
            element={
              <PrivateRoute>
                <DictionaryItem />
              </PrivateRoute>
            }
          />

          <Route
            exact
            path="/accademic"
            element={
              <PrivateRoute>
                <Accademic />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/campas"
            element={
              <PrivateRoute>
                <Campas />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/building"
            element={
              <PrivateRoute>
                <Building />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/room"
            element={
              <PrivateRoute>
                <Room />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/school"
            element={
              <PrivateRoute>
                <School />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/department"
            element={
              <PrivateRoute>
                <Department />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/programme"
            element={
              <PrivateRoute>
                <Programme />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/enrollment"
            element={
              <PrivateRoute>
                <Enrollment />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/timetable"
            element={
              <PrivateRoute>
                <TimeTable />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/exam-timetable"
            element={
              <PrivateRoute>
                <ExamTimetable />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/uploaded-timetable"
            element={
              <PrivateRoute>
                <UploadedTimetable />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/settings/room-constraints"
            element={
              <PrivateRoute>
                <RoomConstraints />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/settings/instructor-preferences"
            element={
              <PrivateRoute>
                <InstructorPreferences />
              </PrivateRoute>
            }
          />
        </Route>
      </Routes>
    </>
  );
}
